import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { PairLiquidityFormatted } from '@root/entities/pair/ui/common/pair-liquidity-formatted'
import {
  CountMax3DigitsFormatted,
  MarkerCapShortFormatted,
} from '@root/shared/core/format'

import { CreatorPairsTableAthCell } from './creator-pairs-table-ath-cell'
import { CreatorPairsTableCreatedCell } from './creator-pairs-table-created-cell'
import { CreatorPairsTableMigratedCell } from './creator-pairs-table-migrated-cell'
import { CreatorPairsTablePairCell } from './creator-pairs-table-pair-cell'

import type { CreatorPairsTableColumn } from '../../atoms/reatom-creator-pairs-table'
import type { PairModel } from '@root/entities/pair'
import type { Column } from '@root/shared/ui-kit'

const MarketCapCell: React.FC<{ pair: PairModel }> = ({ pair }) => {
  const [marketCapUsd] = useAtom(pair.marketCapUsd)
  return (
    <CellRoot>
      <MarkerCapShortFormatted mcap={marketCapUsd} />
    </CellRoot>
  )
}

const LiquidityCell: React.FC<{ pair: PairModel }> = ({ pair }) => {
  return (
    <CellRoot>
      <PairLiquidityFormatted pair={pair} />
    </CellRoot>
  )
}

const HoldersCell: React.FC<{ pair: PairModel }> = ({ pair }) => {
  const [holdersCount] = useAtom(pair.holdersCount)
  return (
    <CellRoot>
      <CountMax3DigitsFormatted count={holdersCount} />
    </CellRoot>
  )
}

const CellRoot = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--text-11);
`

export const createCreatorPairsTableColumns = (): Array<
  Column<PairModel, CreatorPairsTableColumn, undefined>
> => {
  const columns: Array<Column<PairModel, CreatorPairsTableColumn, undefined>> =
    [
      {
        id: 'pair',
        header: ({ t }) => t('token'),
        render: ({ value }) => <CreatorPairsTablePairCell pair={value} />,
        minWidth: 140,
      },
      {
        id: 'createdAt',
        header: ({ t }) => t('common.created'),
        render: ({ value }) => <CreatorPairsTableCreatedCell pair={value} />,
        minWidth: 60,
        maxWidth: 80,
      },
      {
        id: 'migrated',
        header: ({ t }) => t('pair.migrated'),
        render: ({ value }) => <CreatorPairsTableMigratedCell pair={value} />,
        minWidth: 60,
        maxWidth: 90,
      },
      {
        id: 'mcap',
        header: ({ t }) => t('trade.market-cap-short'),
        render: ({ value }) => <MarketCapCell pair={value} />,
        minWidth: 70,
      },

      {
        id: 'liquidity',
        header: ({ t }) => t('common.liquidity'),
        render: ({ value }) => <LiquidityCell pair={value} />,
        minWidth: 70,
      },
      {
        id: 'holders',
        header: ({ t }) => t('table.holders'),
        render: ({ value }) => <HoldersCell pair={value} />,
        minWidth: 60,
        maxWidth: 80,
      },
      // {
      //   id: 'pnl',
      //   header: ({ t }) => t('common.pnl'),
      //   render: ({ value }) => <CreatorPairsTablePnlCell pair={value} />,
      //   minWidth: 60,
      // },
      // {
      //   id: 'bondingCurveProgress',
      //   header: () => 'Bonding Curve Progress',
      //   render: ({ value }) => <CreatorPairsTableBondingCell pair={value} />,
      //   minWidth: 120,
      //   justify: 'stretch',
      // },
      {
        id: 'ath',
        header: ({ t }) => t('common.ath'),
        render: ({ value }) => <CreatorPairsTableAthCell pair={value} />,
        minWidth: 70,
      },
    ]

  return columns
}
